export default {
  randomNumber(amonth) {
    let data = [];
    for (var i = 0; i < amonth; i++) {
      data.push(Math.floor((Math.random() * 100) + 1))
    }
    return data
  },
  randomRgba() {
    var o = Math.round, r = Math.random, s = 255;
    return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ')';
  },
  maxNum(arr) {
    var max = arr.reduce(function(a, b) {
      return Math.max(a, b);
    });
    return max;
  },
  getMonthTH(index) {
    var month_th = [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน ",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม"
    ];
    return month_th[index];
  },
  checkStandartFortest(value) {
    if(value == 'sms'){
      return 3.4
    }else if(value == 'voice'){
      return 3.3
    }else if(value == 'mms'){
      return 3.4
    }if(value == 'data'){
      return 3.5
    }else{
      return 3.3
    }
  }
}
